<div class="my-5">
  <!-- page-header -->
  <sm-page-header
    [breadcrumb]="breadcrumb"
    title="settings.passingMode.title">
  </sm-page-header>
  <!-- content -->
  <div class="content">
    <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data" [loading]="loading" [totalRecords]="totalRecords"></sm-data-table-builder>
  </div>
  <sm-drawer #drawer [drawer]="passingModeDrawer"></sm-drawer>
  <sm-dialog #dialog [dialog]="passingModeDialog"></sm-dialog>
</div>
